var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"prop":_vm.inputProp}},[_vm._t("label"),_c('el-input',{attrs:{"type":_vm.type,"rows":_vm.rows,"resize":_vm.resize,"maxlength":_vm.maxlength,"show-word-limit":_vm.showWordLimit,"disabled":_vm.isDisabled},on:{"input":_vm.onInputChange},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }